import React, {useState, useEffect} from 'react'
import DynamicAlert from "../../helpers/dynamicAlert";
import {getHandleBlur, getHandleInput} from "../../utils/dateValidator";
import {ChangeAuthFlowButton} from "../auth0ActionButtons/ChangeAuthFlowButton";
import {CHANGE_TYPE} from "../../service/auth/ACR";
import {useLocation, useNavigate} from "react-router-dom";

export const Profile = (profs) => {
    const location = useLocation();
    const navigate = useNavigate();
    const {
        handleSubmit,
        handleDelete,
        handleChange,
        userProfile,
        initialUserProfile,
        error,
        alert,
        showAlert,
        isDeleting,
        isSaving
    } = profs;

    const [input, setInput] = useState("");
    const [showChangeEmail] = useState(true);
    const [showChangePhone] = useState(true);
    const [isChanged, setIsChanged] = useState(false);

    const handleInput = (event) => {
        if (event.target.value.length <= 10) {
            const value = getHandleInput(event);
            handleChange({target: {name: 'birthday', value: value}})
            setInput(value);
        }
    };

    const handleBlur = (event) => {
        if (event.target.value.length < 11) {
            const value = getHandleBlur(event);
            if (value) {
                handleChange({target: {name: 'birthday', value: value}})
                setInput(value);
            }
        }
    };

    const keysToCompare = ["phoneNo", "firstName", "lastName", "birthday"];


    useEffect(() => {
        if (userProfile?.birthday) {
            setInput(userProfile?.birthday);

        }
        if (initialUserProfile == null || userProfile == null) {
            setIsChanged(false);
            return;
        }
        setIsChanged(keysToCompare.some(
            key => JSON.stringify(initialUserProfile[key]) !== JSON.stringify(userProfile[key])
        ));

    }, [userProfile, initialUserProfile]);

    useEffect(() => {

        const incomingAlert = location.state?.alert;

        if (!incomingAlert) return;

        showAlert(incomingAlert.msg, incomingAlert.type);

        navigate(location.pathname, {
            replace: true,
            state: null,
        });
    }, [location, navigate]);


    return (
        <div className="mfa-body">
            <div className="mfa-container">
                <div className="text-center m-6-auto">
                    <DynamicAlert alert={alert}/>
                    <div className="p-1 py-2">
                        <div className="text-center m-6-auto section-title">
                            <h4>Account Information</h4>
                        </div>
                        <h6 id="note">All fields required *
                        </h6>
                        <div className="form-group email-input-container">
                            <label htmlFor="email" className="userLabel">
                                Email *
                            </label>

                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    placeholder="Email"
                                    id="email"
                                    name="email"
                                    value={userProfile?.email}
                                    className="form-control"
                                    disabled
                                    aria-label="User email"
                                />

                                {showChangeEmail && (
                                    <ChangeAuthFlowButton
                                        change_type={CHANGE_TYPE.EMAIL}
                                        email={userProfile?.email}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="p-1">
                        <div className="text-center m-6-auto section-title">
                            <h4>Personal Information</h4>
                        </div>

                        <div className="form-group">
                            <label className={"userLabel"}>First Name *</label>
                            <input
                                type="text"
                                name="firstName"
                                className="form-control"
                                placeholder="First Name"
                                onChange={handleChange}
                                id="firstName"
                                defaultValue={userProfile?.firstName}
                                value={userProfile?.firstName || ""}
                            />
                            <div className="text-danger">{error.firstName}</div>
                        </div>

                        <div className="form-group">
                            <label className={"userLabel"}>Last Name *</label>
                            <input
                                type="text"
                                name="lastName"
                                className="form-control"
                                placeholder="Last Name"
                                onChange={handleChange}
                                id="lastName"
                                defaultValue={userProfile?.lastName}
                                value={userProfile?.lastName || ""}
                            />
                            <div className="text-danger">{error.lastName}</div>
                        </div>
                        <div className="form-group email-input-container">
                            <label className={"userLabel"}>Primary Phone Number *</label>

                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    placeholder="PhoneNo"
                                    id="phoneno"
                                    name="phoneNo"
                                    value={userProfile?.phoneNo}
                                    className="form-control"
                                    disabled
                                    aria-label="User PhoneNumber"
                                />

                                {showChangePhone && (
                                    <ChangeAuthFlowButton
                                        change_type={CHANGE_TYPE.PHONE}
                                        email={userProfile?.email || ""}
                                    />
                                )}
                            </div>

                            <div className="text-danger">{error.phoneNo}</div>
                        </div>
                        <div className="form-group">
                            <label className={"userLabel"}>Date of Birth</label>
                            <input
                                type="text"
                                name="birthday"
                                className="form-control"
                                placeholder="MM/DD/YYYY"
                                id="birthday"
                                value={input}
                                onChange={handleInput}
                                onBlur={handleBlur}
                            />

                            <div className="text-danger">{error.birthday}</div>
                        </div>
                        <div style={{display: "flex", gap: "12px"}}>
                            <button
                                type="button"
                                onClick={handleSubmit}
                                disabled={!isChanged || isSaving}
                                style={{
                                    flex: 1,
                                    height: "35px",
                                    border: "none",
                                    borderRadius: "30px",
                                    backgroundColor: isChanged ? "#008236" : "#8fc7a4",
                                    color: "#fff",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    cursor: isChanged ? "pointer" : "not-allowed",
                                    transition: "all 0.2s ease",
                                    boxShadow: isChanged ? "0 4px 10px rgba(0,0,0,0.15)" : "none",
                                    opacity: isChanged ? 1 : 0.75,
                                }}
                            >
                                {isSaving ? "Saving..." : "Save"}
                            </button>

                            <button
                                type="button"
                                onClick={handleDelete}
                                disabled={isDeleting}
                                style={{
                                    flex: 1,
                                    height: "35px",
                                    border: "none",
                                    borderRadius: "30px",
                                    backgroundColor: isDeleting ? "#c78f8f" : "#a40000",
                                    color: "#fff",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    cursor: isDeleting ? "not-allowed" : "pointer",
                                    transition: "all 0.2s ease",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                                    opacity: isDeleting ? 0.8 : 1,
                                }}
                            >
                                {isDeleting ? "Redirecting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}
